/* global femcare */

/**
 * Represents the quick filters for category headings functionality.
 */
femcare.product.productFilterCategory = {
    /**
     * Initializes the product filter category.
     */
    init() {
        this.$categoryFilterContainer = $('.product-quick-filter--category');
        this.$categoryHeadings = $('.category-heading');
        this.activeCategory = null;

        if (this.$categoryFilterContainer.length) {
            this.createFilterButtons();
            this.bindFilterButtonEvents();
            femcare.shared.progressBar.init('.product-filter__list', '.product-quick-filter__progress');
        }
    },

    /**
     * Creates filter buttons based on category headings.
     */
    createFilterButtons() {
        const uniqueCategories = this.extractUniqueCategories();
        const $filterList = this.$categoryFilterContainer.find('.product-filter__list');

        uniqueCategories.forEach(category => {
            const $filterItem = $('<li>').append($('<button>', {
                class: 'quick-filter__option product-filter__option',
                'data-category': category
            }).append($('<div>', {
                class: 'btn btn-secondary product-filter__chip',
                text: category
            })));

            $filterList.append($filterItem);
        });
    },

    /**
     * Extracts unique categories from category headings.
     * @returns {Array} - Array of unique categories.
     */
    extractUniqueCategories() {
        const categories = [];
        this.$categoryHeadings.each((index, element) => {
            const category = $(element).data('category');
            if (!categories.includes(category)) {
                categories.push(category);
            }
        });

        return categories;
    },

    /**
     * Binds click events to filter buttons.
     */
    bindFilterButtonEvents() {
        const $filterButtons = this.$categoryFilterContainer.find('.quick-filter__option');

        $filterButtons.on('click', event => {
            const $clickedButton = $(event.currentTarget);
            const category = $clickedButton.data('category');

            if (category === 'all') {
                $filterButtons.removeClass('quick-filter__option--active');
                $clickedButton.addClass('quick-filter__option--active');
                this.resetFilter();
                this.displayAllCategories();
            } else {
                if (this.activeCategory === category) {
                    this.resetFilter();
                    this.displayAllCategories();
                    $filterButtons.removeClass('quick-filter__option--active');
                    this.$categoryFilterContainer.find('.quick-filter__option[data-category="all"]').addClass('quick-filter__option--active');
                } else {
                    this.setActiveCategory(category);
                    this.updateCategoryDisplay();
                    $filterButtons.removeClass('quick-filter__option--active');
                    $clickedButton.addClass('quick-filter__option--active');
                }
            }
        });
    },

    /**
     * Updates the display of category headings based on active filter.
     */
    updateCategoryDisplay() {
        this.$categoryHeadings.hide();
        if (!this.activeCategory) {
            this.displayAllCategories();
        } else {
            this.$categoryHeadings.filter(`[data-category="${this.activeCategory}"]`).show();
        }
    },

    /**
     * Displays all category headings.
     */
    displayAllCategories() {
        this.$categoryHeadings.show();
    },

    /**
     * Resets filter.
     */
    resetFilter() {
        this.activeCategory = null;
    },

    /**
     * Sets the active category.
     * @param {string} category - The category to activate.
     */
    setActiveCategory(category) {
        this.activeCategory = category;
    },
};
